import { PricingType, UnitDecimals } from '~/constants';
import { display } from '../../common';
import { formatDollars, formatNumber } from '~/utils/formatNumber';
import { getProjectBidOverallAmount, normalizeToPerWdc } from '~/utils/calculators/costsFns';
import { sizeKwdc } from '~/utils/calculators';
import { ProjectBid } from '~/types/project';

interface Bid {
  unit: string;
  amount: number;
}

export default function bidAmount(project: any) {
  const bid = project?.pendingBid ?? {};
  const { unit, amount } = bid as Bid;
  const decimals = UnitDecimals[unit] ?? 0;

  if (!amount || !unit) {
    // Returns "—"
    return display(undefined);
  } else if (project.pricingType === PricingType.ITC) {
    // Return format X.XX%
    return display(`${formatDollars(getProjectBidOverallAmount(project, bid), { dec: 0 })} or ${formatNumber(amount, undefined, { minDec: 0, maxDec: 4 })}% of ITC value `);
  } else if (project.pricingType === PricingType.ACQUISITION) {
    // Return format $X or $X per Wdc
    const overall = getProjectBidOverallAmount(project, bid);
    const perWdc = normalizeToPerWdc(sizeKwdc(project), { amount: overall } as ProjectBid);
    return display(`${formatDollars(overall, { dec: 0 })} or ${formatDollars(perWdc, { dec: UnitDecimals.WDC })} / Wdc`);
  } else {
    return display(formatDollars(amount, { dec: decimals }));
  }
}